import React from 'react';

import './index.css';


const getText = () => (
  <div styleName="textContainer">
    {/* <strong>Market Order</strong>
    <br />
    When you place a Market Order, you are asking for an immediate execution at the best
    price available in the marketplace. Market orders are the most common type of order,
    and have the advantage of nearly always being filled, since a market order does not
    specify a price at which the trade is to be executed.
    <br />
    <br />
    In a volatile fast moving market, a market order may receive an execution price
    significantly different from the quoted price of that security when the order was
    entered. Also, if you place a market order when the markets are closed, such as
    at night, over weekends or on market holidays, your order will be executed when the
    market next opens. There can be substantial changes between the most recent closing
    price of a security (which is the price usually quoted on the site during hours when
    the market is not open) and the next opening or available price.
    <br />
    <br /> */}
    <strong>Limit Order</strong>
    <br />
    A limit order allows you to specify the price (the limit) you would like your order
    to be executed at. A limit order to buy a security means that the order will be
    executed at the limit price or lower, and a limit order to sell a security means
    that the order will be executed at the limit price or higher. Limit orders have the
    advantage, when they are executed, of being executed at a specific price, or better;
    however your limit order may never be executed because the limit price may never be
    met or the market could quickly move away from your limit price before your order can
    be filled.
    <br />
    <br />
    {/* <strong>Stop Order</strong>
    <br />
    With stop orders, you place an order to be executed only after the stock has reached
    a specified price (the stop price). A stop order to buy a security is placed above
    the current market price and automatically becomes a market order to buy when the stop
    price is reached. A stop order to sell a security is placed below the current market price
    and automatically becomes a market order to sell when the stop price is reached.
    <br />
    <br />
    As with any market order in volatile markets, the market order triggered at the stop
    price may receive an execution price significantly different from the stop price of that
    security when the order is triggered. Also a stop order may be executed at a price very
    different from the stop price if, for example, the stop order was entered after a market
    close and the security subsequently opens at a price much higher or lower, as compared to
    the applicable stop price.
    <br />
    <br /> */}
    <strong>Stop-Limit Order</strong>
    <br />
    A stop-limit order is an order to buy or sell a stock that combines the features of a stop
    order and a limit order. Once the stop price is reached, the stop-limit order becomes a limit
    order to buy or to sell at the specified price.
    <br />
    <br />
    The benefit of a stop-limit order is that you can control the price at which the trade will get
    executed. As with all limit orders, a stop-limit order may never get filled if the stock’s price
    never reaches the specified stop and limit prices. This may happen especially in fast-moving
    markets where prices fluctuate dramatically.
  </div>
);

export default getText;



// WEBPACK FOOTER //
// ./src/components/SecurityTrade/DisclaimerViews/OrderTypeText.js